import React from 'react';
import { Eye, Award, Clock, GraduationCap, BookOpen } from 'lucide-react';
const trustItems = [{
  icon: Eye,
  label: '360° Situational Awareness'
}, {
  icon: Award,
  label: 'Highest Quality of Service'
}, {
  icon: Clock,
  label: '24/7 Customer Support'
}, {
  icon: GraduationCap,
  label: 'Training & Consulting'
}, {
  icon: BookOpen,
  label: 'Course Development'
}];
export function TrustStrip() {
  return <section className="py-8 border-b border-brand-gray-800 bg-brand-gray-900/60" data-id="element-755">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-756">
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-4" data-id="element-757">
          {trustItems.map(item => <div key={item.label} className="flex items-center gap-2.5" data-id="element-758">
              <item.icon className="w-4 h-4 text-brand-teal flex-shrink-0" data-id="element-759" />
              <span className="text-xs font-semibold text-brand-gray-300 uppercase tracking-wider" data-id="element-760">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}